import logo from "../assets/images/logo.svg";

const Logo = () => {
  return <img src={logo} className="logo" alt="jobster logo" />;
};

export default Logo;